export default __webpack_public_path__ + "static/media/sn-kakutei.62f8ea97.jpg";